var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "form",
      {
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.submit.apply(null, arguments)
          },
        },
      },
      [
        _c("h4", [_vm._v("Purchase Order Comment")]),
        _c("validated-input", {
          attrs: {
            placeholder: "Enter comment to include on all purchase orders",
          },
          model: {
            value: _vm.purchaseOrderComment,
            callback: function ($$v) {
              _vm.purchaseOrderComment = $$v
            },
            expression: "purchaseOrderComment",
          },
        }),
        _c(
          "div",
          { staticClass: "d-flex mt-2" },
          [
            _c("b-button", { attrs: { variant: "primary", type: "submit" } }, [
              _vm._v("Save"),
            ]),
            _vm.status === "saving"
              ? _c("b-spinner", {
                  staticClass: "ml-2 align-self-center",
                  attrs: { small: "" },
                })
              : _vm._e(),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }